/** Dialog shown during advanced RX creation when user's initial harvest history crop selections do not meet criteria
    for creating an advanced RX. */

import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

// @tcc
import { getMessage } from 'util/locale';

// selectors
import { getMinimumRequirementsErrorModal } from 'current/uiwidgets/selectors';

// actions
import { closeMinimumRequirementsErrorModal } from 'current/uiwidgets';

// components
import BaseModal from 'common/modals/BaseModal';
import HtmlText from 'html-text/HtmlText';
import { FIELD_VIEW_URL } from 'constants/urls';

const baseString = 'vra-layer-inclusion-modal';
let MinimumRequirementsErrorModal = ({
  minimumRequirementsErrorModal,
  onCancel,
  onUploadYieldData
}) => minimumRequirementsErrorModal ? (
  <BaseModal
    cancelText={getMessage('button-text__upload-yield-data')}
    onCancel={onUploadYieldData}
    onSave={onCancel}
    saveText={getMessage('button-text__okay')}>
    <div className={baseString}>
      <header>{ getMessage('title-text__minimum-requirements-error-modal') }</header>
      <HtmlText messageKey='text__minimum-requirements-error-modal' />
    </div>
  </BaseModal>
) : null;

MinimumRequirementsErrorModal.propTypes = {
  minimumRequirementsErrorModal: propTypes.object,
  onCancel: propTypes.func.isRequired,
  onUploadYieldData: propTypes.func.isRequired
};

MinimumRequirementsErrorModal = connect(
  (state) => {
    return {
      minimumRequirementsErrorModal: getMinimumRequirementsErrorModal(state)
    };
  },
  (dispatch) => {
    return {
      onCancel: () => {
        dispatch(closeMinimumRequirementsErrorModal());
      },
      onUploadYieldData: () => {
        dispatch(closeMinimumRequirementsErrorModal());
        // TODO add code for cleaning up new RX.
        window.location = FIELD_VIEW_URL.DATA_INBOX;
      }
    };
  }
)(MinimumRequirementsErrorModal);

export default MinimumRequirementsErrorModal;
